import {apiClient, getCookie, setCookie, setProfileCookies} from "./api";
import $ from "jquery";
import {toggleLoadingIndicator} from "./user_bitmaps";

export async function fetchMe() {
    // Initially disable the form and button
    $('#profile-form input, #submit-btn').prop('disabled', true);

    return new Promise((resolve, reject) => {
        apiClient('/api/profile/me/', {
                method: 'GET'
            },
            (profile) => {
                // Enable the form fields and the submit button
                $('#profile-form input').prop('disabled', false);
                $('#submit-btn').prop('disabled', false);

                populateProfileForm(profile);

                // Add event listener for form submission
                $('#profile-form').on('submit', function(event) {
                    event.preventDefault();
                    saveProfileData();
                });
                
                resolve(profile);
            },
            (error) => {
                console.error('Error fetching profile:', error);
                $('#gallery-container').html("<p>Error loading profile.</p>");
                reject(error);
            });
    });
}

function populateProfileForm(profile) {
    $('#profile_form_id').val(profile.id)
    $('#profile_first_name').text(profile.first_name);
    $('#profile_last_name').text(profile.last_name);
    $('#profile_slug').text(profile.slug);

    let profile_user_gallery_link = '<a href="/create/'+profile.slug+'/">/create/'+profile.slug+'/</a>';

    $('#profile_user_gallery_link').html(profile_user_gallery_link);
    $('#profile_form_first_name').val(profile.first_name);
    $('#profile_form_last_name').val(profile.last_name);
    $('#profile_form_username').val(profile.username);
    $('#profile_form_nickname').val(profile.nickname);
    $('#profile_form_slug').val(profile.slug);
    // $('#slug').val(profile.slug);

    updateHeaderName();

    // If the API returns a profile image URL, display it in the image preview
    if (profile.photo) {
        $('#photoPreview').attr('src', profile.photo);
    } else {
        // If no image is available, you can set a placeholder or hide the image preview
        $('#photoPreview').attr('src', ''); // or set a placeholder image
    }
}

function saveProfileData() {

    let profileFirstName = $('#profile_form_first_name').val();
    let profileLastName = $('#profile_form_last_name').val();
    let profileNickname = $('#profile_form_nickname').val();

    // Build formData object.
    let formData = new FormData();
    formData.append('first_name', profileFirstName);
    formData.append('last_name', profileLastName);
    formData.append('slug', profileNickname);

    apiClient('/api/profile/me/', {
            method: 'PATCH',
            body: formData,
        },
        (profile) => {
            setProfileCookies(profile);
            updateHeaderName();
            $('#message').text("Profile updated successfully.");
        },
        (error) => {
            $('#message').text("Failed to update profile. Please try again.");
            console.error('Error updating profile:', error);
        });
}

export function updateHeaderName() {
    let first_name = getCookie('first_name');
    let last_name = getCookie('last_name');
    let nickname = getCookie('nickname');

    let profile_name = first_name + ' ' + last_name;
    if (nickname !== "") {
        profile_name = nickname;
    }
    if (!profile_name || profile_name.trim() === "") {
        profile_name = "--unknown--"
    }
    profile_name = profile_name.trim();

    $('#header_nickname').text(profile_name);
}

export async function fetchMyProfile() {
    apiClient('/api/profile/me/', {
        method: 'GET'
    },
    (profile) => {
        setProfileCookies(profile);
        updateHeaderName();

        // Redirect to the dashboard or reload the page
        window.location.href = "/";
    },
    (error) => {
        console.error('Error fetching profile:', error);
    });
}
